module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/thurston_cover.7004f47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/thurston_cover.jpg
// module id = 61yk
// module chunks = 1